// Init form
function initForm() {
  // Select dropdowns
  const dropdowns = document.querySelectorAll(".PreferenceForm__Section .QuestionDropdown");

  // Init dropdowns
  dropdowns.forEach(dropdown => initDropdown(dropdown));

  // Init footer buttons
  initButtons();

  // Try to recover answers from last session
  recoverSession();

  // Subscribe form
  KlaviyoSubscribe.attachToForms('#KlaviyoForm', {
    hide_form_on_success: false,
    success: recoverSession,
    extra_properties: {
      $source: '$embed',
      $method_type: "Klaviyo Form",
      $method_id: 'embed',
      $consent_version: '',
      "Preference Center": "true"
    }
  });

  window.addEventListener("load", (event) => {
    while(!document.getElementById("step-1").checked) {
      document.getElementById("step-1").checked = true;
    }
  })

}

// Recover last session from session storage (if exists)
function recoverSession() {
  // Recover the values from localStorage for each step
  if(localStorage.getItem("questionnaire")) {
    let data = JSON.parse(localStorage.getItem("questionnaire"));
    
    if(data.Step1) {
      let step = document.querySelector('[data-step="1"]');
      let stepQuestions = step.querySelectorAll(".QuestionDropdown");
      stepQuestions.forEach(stepQuestion => {
        let stepQuestionOptions = stepQuestion.querySelectorAll("input");

        stepQuestionOptions.forEach(option => {
          if(data.Step1[stepQuestion.dataset.option]?.includes(option.value)) {
            option.click();
          }
        })
      });
    }

    if(data.Step2) {
      let step = document.querySelector('[data-step="2"]');
      let stepInputs = step.querySelectorAll("input");

      stepInputs.forEach(input => {
        if(input.value == data.Step2[input.name]) {
          input.checked = true;
        }
      });
    }

    if(data.Step3) {
      let step = document.querySelector('[data-step="3"]');
      let stepInputs = step.querySelectorAll("input");

      stepInputs.forEach(input => {
        if(input.type === "radio") {
          if(input.value == data.Step3[input.name]) {
            input.click();
          }
        } else {
          input.value = data.Step3[input.name];
        }
      });
    }
  }
}

// Init dropdowns
function initDropdown(dropdown) {
  // If the input is dynamic, display the options conditionally and refresh whenever the static dropdowns are updated
  if(dropdown.classList.contains("QuestionDropdown--dynamic")) {
    let genderDropdown = document.querySelector("details[data-option='Geschlecht']");
    let categoryDropdown = document.querySelector("details[data-option='Kategorien']");
    let staticDropdowns = document.querySelectorAll("details[data-option='Kategorien'], details[data-option='Geschlecht']");

    staticDropdowns.forEach(staticDropdown => {
      staticDropdown.querySelectorAll("input").forEach(input => {
        input.addEventListener('click', function() {
          let activeGenders = [];
          let activeCategories = [];
  
          genderDropdown.querySelectorAll("input").forEach(dropdownInput => {
            if(dropdownInput.checked) {
              activeGenders.push(dropdownInput.value);
            }
          });
  
          categoryDropdown.querySelectorAll("input").forEach(dropdownInput => {
            if(dropdownInput.checked) {
              activeCategories.push(dropdownInput.value);
            }
          });

          dropdown.querySelectorAll(".QuestionDropdown__Content--option").forEach(dropdownOption => {
            const dropdownOption1 = dropdownOption.dataset.geschlecht.split(";").filter(gender => activeGenders.includes(gender));
            const dropdownOption2 = dropdownOption.dataset.kategorie.split(";").filter(category => activeCategories.includes(category));

            if(dropdownOption1.length && dropdownOption2.length) {
              dropdownOption.classList.add("active");
            } else {
              dropdownOption.classList.remove("active");

              if(dropdownOption.querySelector("input").checked) {
                dropdownOption.querySelector("input").click();
              }
            }
          });

          if(!activeGenders.length || !activeCategories.length) {
            dropdown.classList.add("QuestionDropdown--disabled");
          } else {
            dropdown.classList.remove("QuestionDropdown--disabled");
          }
        });
      });
    });
  }

  // If the input has searchbar, init the search function
  if(dropdown.classList.contains("QuestionDropdown--hasSearch")) {
    let searchInput = dropdown.querySelector(".QuestionDropdown__Content--searchBar input");
    let dropdownOptions = dropdown.querySelectorAll(".QuestionDropdown__Content--option");

    searchInput.addEventListener("input", function() {
      if(searchInput.value.length >= 1) {
        dropdownOptions.forEach(dropdownOption => {
          if(dropdownOption.dataset.value.toLowerCase().includes(searchInput.value)) {
            dropdownOption.classList.remove("hidden");
          } else {
            dropdownOption.classList.add("hidden");
          }
        })
      } else {
        dropdownOptions.forEach(dropdownOption => {
          dropdownOption.classList.remove("hidden");
        })
      }
    })
  }

  // Change count on dropdown summary and position selected inputs at the top if the option count is bigger than 10
  let summaryCount = dropdown.querySelector(".QuestionDropdown__Summary--count");
  let options = dropdown.querySelectorAll(".QuestionDropdown__Content--option input");

  options.forEach(option => {
    option.addEventListener('input', function() {
      let activeOptionsCount = 0;
      let hasSearch = dropdown.classList.contains("QuestionDropdown--hasSearch") ? 1 : 0;

      options.forEach(activeOption => {
        if(activeOption.checked) {
          activeOptionsCount++;

          activeOption.closest(".QuestionDropdown__Content--option").style.gridRow = activeOptionsCount + hasSearch;
        } else {
          activeOption.closest(".QuestionDropdown__Content--option").style.gridRow = "auto";
        }
      });
      
      // Change count on dropdown summary
      summaryCount.innerText = activeOptionsCount ? activeOptionsCount + " ausgewählt" : "";
    })
  })

  // Close the dropdown when another element is clicked
  window.addEventListener('click', function(event) {
    if(!dropdown.contains(event.target)) {
      closeDropdown(dropdown);
    }
  })
}

function closeDropdown(dropdown) {
  // If there's a search bar, reset the input value
  if(dropdown.classList.contains("QuestionDropdown--hasSearch")) {
    let searchInput = dropdown.querySelector(".QuestionDropdown__Content--searchBar input");

    searchInput.value = "";
    let options = dropdown.querySelectorAll(".QuestionDropdown__Content--option");
    
    options.forEach(option => {
      option.classList.remove("hidden");
    })
  }

  // Close the dropdown
  dropdown.removeAttribute("open");
}

// Init footer buttons
function initButtons() {
  // Select buttons and pagination inputs
  const paginationStepInputs = document.querySelectorAll('[name="step"]');
  const prevBtn = document.querySelector('[data-action="prev"]');
  const nextBtn = document.querySelector('[data-action="next"]');
  const submitBtn = document.querySelector('[data-action="submit"]');
  let activeStep = 1;

  paginationStepInputs.forEach(paginationStepInput => {
    paginationStepInput.addEventListener("input", function() {
      activeStep = Array.from(paginationStepInputs).find(input => input.checked).value;
      activeStep = parseInt(activeStep);
  
      // Update buttons depending on the step
      updateButtons(activeStep);
    });
  })

  // Go to previous step
  prevBtn.addEventListener('click', function() {
    let currentStepInput = document.getElementById(`step-${activeStep}`);
    let prevStepInput = document.getElementById(`step-${activeStep - 1}`);

    currentStepInput.disabled = true;
    prevStepInput.click();
  });


  nextBtn.addEventListener('click', function() {
    if(evalStep(activeStep)) {
      // Unlock next step and mark it as active
      let nextStepInput = document.getElementById(`step-${activeStep + 1}`);
      nextStepInput.removeAttribute("disabled");
      nextStepInput.click();
    }
  })

  submitBtn.addEventListener('click', function() {
    if(evalStep(activeStep)) {
      // Submit the form
      document.querySelector("#KlaviyoFormSubmit").click();

      let nextStepInput = document.getElementById(`step-${activeStep + 1}`);
      nextStepInput.removeAttribute("disabled");
      nextStepInput.click();

      let questionnaireStored = JSON.parse(localStorage.getItem("questionnaire")) || {};
      questionnaireStored.hasSubscribed = true;
      
      localStorage.setItem("questionnaire", JSON.stringify(questionnaireStored));
    }
  });

  function updateButtons(step) {
    const stepBlock = document.querySelector('[data-step="' + step + '"]');

    if(step == 1) {
      prevBtn.style.display = "none";
      nextBtn.style.display = "block";
      nextBtn.setAttribute("disabled", true);
      submitBtn.style.display = "none";

      stepBlock.addEventListener('click', function() {
        let isComplete = true;

        const requiredQuestions = stepBlock.querySelectorAll('[data-required="true"]');

        requiredQuestions.forEach(requiredQuestion => {
          if(!requiredQuestion.querySelector("input:checked")) {
            isComplete = false;
          }
        });

        if(isComplete) {
          nextBtn.removeAttribute("disabled");
        } else {
          nextBtn.setAttribute("disabled", true);
          document.getElementById("step-2").setAttribute("disabled", true);
          document.getElementById("step-3").setAttribute("disabled", true);
          document.getElementById("step-4").setAttribute("disabled", true);
        }
      });
    }
  
    if(step == 2) {
      prevBtn.style.display = "block";
      nextBtn.style.display = "block";
      nextBtn.setAttribute("disabled", true);
      submitBtn.style.display = "none";

      stepBlock.addEventListener('click', function() {
        let isComplete = true;

        const requiredQuestions = stepBlock.querySelectorAll('[data-required="true"]');

        requiredQuestions.forEach(requiredQuestion => {
          if(!requiredQuestion.querySelector("input:checked")) {
            isComplete = false;
          }
        });

        if(isComplete) {
          nextBtn.removeAttribute("disabled");
        } else {
          nextBtn.setAttribute("disabled", true);
          document.getElementById("step-3").setAttribute("disabled", true);
          document.getElementById("step-4").setAttribute("disabled", true);
        }
      });
    }
  
    if(step == 3) {
      prevBtn.style.display = "block";
      nextBtn.style.display = "none";
      submitBtn.style.display = "block";

      if(!stepBlock.querySelector("input[required]").value) {
        submitBtn.setAttribute("disabled", true);
      } else {
        submitBtn.removeAttribute("disabled");
      }

      stepBlock.querySelector("input[required]").addEventListener('input', function() {
        let isComplete = true;
  
        if(!stepBlock.querySelector("input[required]").value) {
          isComplete = false;
        }
  
        if(isComplete) {
          submitBtn.removeAttribute("disabled");
        } else {
          submitBtn.setAttribute("disabled", true);
          document.getElementById("step-4").setAttribute("disabled", true);
        }
      });
    }
  
    if(step == 4) {
      prevBtn.style.display = "none";
      nextBtn.style.display = "none";
      submitBtn.style.display = "none";

      document.getElementById("step-1").setAttribute("disabled", true);
      document.getElementById("step-2").setAttribute("disabled", true);
      document.getElementById("step-3").setAttribute("disabled", true);
    }

    stepBlock.click();
  }

  updateButtons(1)
}

// Evaluate if step has been completed correctly
function evalStep(stepNumber) {
  let stepSelector = '.PreferenceForm__Step[data-step="' + stepNumber + '"]';
  let step = document.querySelector(stepSelector);

  let dropdowns = step.querySelectorAll(".PreferenceFormStep__Question--dropdown");
  let radioGroups = step.querySelectorAll(".PreferenceFormStep__Question--radioGroup");
  let inputs = step.querySelectorAll(".PreferenceFormStep__Question--input");

  let isValid = true;
  let stepObj = {};

  dropdowns.forEach(dropdown => {
    if(!Array.from(dropdown.querySelectorAll("input")).find(input => input.checked)) {
      if(dropdown.dataset.required === "true") {
        dropdown.classList.add("PreferenceFormStep__Question--error");
        dropdown.addEventListener("click", function() {
          dropdown.classList.remove("PreferenceFormStep__Question--error");
        });

        isValid = false;
      }
    } else {
      stepObj[dropdown.dataset.option] = Array.from(dropdown.querySelectorAll("input:checked")).map(input => input.value);
    };
  });

  radioGroups.forEach(radioGroup => {
    if(!Array.from(radioGroup.querySelectorAll("input")).find(input => input.checked)) {
      radioGroup.classList.add("PreferenceFormStep__Question--error");
      radioGroup.addEventListener("click", function() {
        radioGroup.classList.remove("PreferenceFormStep__Question--error");
      });
      
      isValid = false;
    } else {
      stepObj[radioGroup.dataset.option] = radioGroup.querySelector("input:checked").value;
    };
  });

  inputs.forEach(input => {
    if(input.type == "email" && !input.value.includes("@")) {
      input.classList.add("PreferenceFormStep__Question--error");
      input.addEventListener("click", function() {
        input.classList.remove("PreferenceFormStep__Question--error");
      });
      
      isValid = false;
    }

    if(!input.value && input.hasAttribute("required")) {      
      input.classList.add("PreferenceFormStep__Question--error");
      input.addEventListener("click", function() {
        input.classList.remove("PreferenceFormStep__Question--error");
      });
      
      isValid = false;
    } else {
      stepObj[input.name] = input.value
    };
  });

  if(isValid) {
    let questionnaireStored = JSON.parse(localStorage.getItem("questionnaire")) || {};
    questionnaireStored["Step" + stepNumber] = stepObj;

    localStorage.setItem("questionnaire", JSON.stringify(questionnaireStored));
  }

  return isValid;
}

document.addEventListener('DOMContentLoaded', function() {
  initForm();
})